export let QueryKeys = /*#__PURE__*/function (QueryKeys) {
  QueryKeys["LegalTerms"] = "LegalTerms";
  QueryKeys["Relationship"] = "Relationship";
  QueryKeys["Draft"] = "Draft";
  QueryKeys["ArchivedProposals"] = "ArchivedProposals";
  QueryKeys["CanResyncQbo"] = "CanResyncQbo";
  QueryKeys["CanResyncXero"] = "CanResyncXero";
  QueryKeys["ServiceTemplatesForBilling"] = "ServiceTemplatesForBilling";
  QueryKeys["Contacts"] = "Contacts";
  QueryKeys["ContactsMap"] = "ContactsMap";
  QueryKeys["ActiveServices"] = "ActiveServices";
  QueryKeys["ProposalTemplates"] = "ProposalTemplates";
  QueryKeys["ServiceBillingDetails"] = "ServiceBillingDetails";
  QueryKeys["GetInfo"] = "getInfo";
  QueryKeys["PromptSuggestions"] = "PromptSuggestions";
  QueryKeys["RichText"] = "RichText";
  QueryKeys["PdfUrl"] = "PdfUrl";
  return QueryKeys;
}({});